// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3Kquv","icon":"SortAdornment_icon__1updy","up":"SortAdornment_up__1oPNB","down":"SortAdornment_down__UL96f","active":"SortAdornment_active__2PKQd"};